import * as yup from 'yup';

export const feedbackFormSchema = yup.object({
	firstName: yup.string().required(),
	lastName: yup.string().required(),
	subject: yup.string().min(10).required(),
	country_id: yup.string().uuid().required(),
	email: yup.string().email(),
	body: yup.string().min(20).required(),
	reason: yup.string().required(),
});

export const feedbackFormDefaultValue = {
	firstName: '',
	lastName: '',
	subject: '',
	country_id: '',
	email: '',
	body: '',
	reason: '',
}